import React from 'react';

// Custom icon components for missing antd-mobile-icons.

type SvgIconProps = React.SVGProps<SVGSVGElement> & {
  title?: string;
};

export const EnergyBatteryIcon: React.FC<SvgIconProps> = ({ title, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    focusable="false"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <rect
      x="3.5"
      y="6.5"
      width="15"
      height="11"
      rx="2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M19.5 10h1.2c.8 0 1.3.5 1.3 1.3v1.4c0 .8-.5 1.3-1.3 1.3h-1.2"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.7"
    />
    <path
      d="M11.5 8.7 8.8 12h2.1l-1.8 3.3 4-4h-2.2l1.7-2.6h-1.1z"
      fill="currentColor"
    />
  </svg>
);

export const BatteryIcon = EnergyBatteryIcon;

export const WalletIcon: React.FC<SvgIconProps> = ({ title, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    focusable="false"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <rect
      x="3.5"
      y="6.5"
      width="17"
      height="12"
      rx="2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M4.5 10h16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.7"
    />
    <circle cx="16.5" cy="14.5" r="1" fill="currentColor" />
  </svg>
);

export const FireIcon: React.FC<SvgIconProps> = ({ title, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    focusable="false"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M12 21c3.9 0 6.5-2.6 6.5-6.2 0-2.7-1.4-4.7-3.2-6.3-.2 1.5-.8 2.5-1.8 3.1.2-3-1.5-5.4-4.1-7.6.2 3.2-1.9 5-3.1 6.9-.7 1.1-1 2.3-1 3.9C5.3 18.4 8.1 21 12 21z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
  </svg>
);
